module.exports = __webpack_public_path__ + "img/K2.b3c0ce12.png";